export function isDebugMode() {
    return new URLSearchParams(window.location.search).has("debug");
}
